import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/sidebar/sidebar";
import Header from "../components/header/header";

const Admin = () => {
  return (
    <div className="wrapper">
      <div className="qa_panel">
        <Sidebar />
        <div className="main">
          <Header />
          <div className="all_content dashboard_content">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;